import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from "../axiosBaseQuery";
import { IPredectivePayload } from "../../interface/IHome";
import { AlertsTablePayload } from '../../interface/IAlerts';

export const forecastApi = createApi({
  reducerPath: 'forecastApi',
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    getScenarioPlanningData: builder.mutation({
        query: (payload: AlertsTablePayload) => ({
            url: '/getScenarioPlanningData',
            method: 'POST',
            data: payload,
        }),
    }),
    getStockOutAnddemandData: builder.mutation({
        query: (payload: IPredectivePayload) => ({
            url: '/getStockOutAnddemandData',
            method: 'POST',
            data: payload,
        }),
    }),
    getInventoryAvailabilityData: builder.mutation({
        query: (payload: IPredectivePayload) => ({
            url: '/getInventoryAvailabilityData',
            method: 'POST',
            data: payload,
        }),
    }),
    updateReviewedForecastData: builder.mutation({
        query: (payload: any) => ({
            url: '/updateReviewedForecastData',
            method: 'POST',
            data: payload,
        }),
    }),
    getForecastCustomerLevelData: builder.mutation({
        query: (payload: any)=>({
            url: "/getForecastCustomerLevelData",
            method: 'POST',
            data: payload
        })
    }),
    getExportData: builder.mutation({
        query: (payload:any)=>({
            url:"/getExportData",
            method:'POST',
            data:payload
        })
    }),
    updateForecastData: builder.mutation({
        query: (payload:any)=>({
            url: "/updateForecastData",
            method: 'POST',
            data: payload
        })
    })
  }),
});

export const {
  useGetScenarioPlanningDataMutation,
  useGetInventoryAvailabilityDataMutation,
  useGetStockOutAnddemandDataMutation,
  useUpdateReviewedForecastDataMutation,
  useGetExportDataMutation,
  useGetForecastCustomerLevelDataMutation,
  useUpdateForecastDataMutation
} = forecastApi;
